// Single source of truth for the app version. Shown under the brand and in the
// welcome dialog; must match package.json and the newest CHANGELOG.TXT entry
// (tests/version.test.ts enforces this). Bump on EVERY commit per semver.
export const VERSION = '0.2.4';
